/*
 * Copyright (c) 2023. Haodong JU
 */

import Vue from 'vue'
import 'chartist/dist/chartist.min.css'
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)

Vue.component('ApexChart', VueApexCharts)
